class ContestLinks {
    static contestLink;
    static contestType;

    constructor(props) {
        this.contestLink = document.querySelectorAll('[rel^="contest"]')[0];

        if(this.contestLink) {
            this.contestType = this.contestLink.getAttribute('rel')

            this.init();
        }
    }

    init() {
        // Set link
        let contestLinkCookie = this.readCookie("fvb-" + this.contestType);
        if (contestLinkCookie !== null) {
            this.populateLink(contestLinkCookie)
        } else {
            this.getContestLink(this.contestType);
        }

        // Fix to prevent (limit) duplicate registrations
        let contestBtnCookie = this.readCookie("fvb_btn-" + this.contestType);
        let pMsg = document.createElement("p");
        let mSpan = document.createElement("span");
        const disclaimer = '**One entry per person.';
        const blockMsg = 'Thank you for entering!';

        mSpan.style.cssText = `
            color: red;
            font-size: .8rem;
        `;

        pMsg.style.cssText = `
            color: red;
            font-size: 1.1rem;
        `;
        mSpan.innerHTML = disclaimer;

        this.contestLink.addEventListener('click',  (e) => {
            //e.preventDefault();

            console.log( this.readCookie("fvb_btn-" + this.contestType));
            if (contestBtnCookie === null) {
                this.contestLink.style.display = 'none';
                this.setCookie('fvb_btn-' + this.contestType, true, 14);
                this.contestLink.parentElement.append(pMsg);
                pMsg.innerHTML = blockMsg + '<br />';
                pMsg.append(mSpan);
            }
        });

        if (contestBtnCookie !== null) {
            // Hide button
            this.contestLink.style.display = 'none';
            this.setCookie('fvb_btn-' + this.contestType, true, 14);
            this.contestLink.parentElement.append(pMsg);
            pMsg.innerHTML = blockMsg + '<br />';
            pMsg.append(mSpan);
        } else {
            this.contestLink.style.display = 'block';
        }
    }

    populateLink = (link) => {
        this.contestLink.setAttribute('href', link);
    };

    getContestLink = () => {
        try {
            if(this.contestType) {
                let wpURL, postObj;

                switch(this.contestType) {
                    case 'contest-checking noopener':
                        this.contestType = 'contest-checking';
                       break;
        
                    case 'contest-mortgage noopener':
                        this.contestType = 'contest-mortgage';
                        
                        break;
                }

                wpURL = "/wp-admin/admin-ajax.php?action=contestlink";
                postObj = { 
                    data: {
                        type: this.contestType || ''
                    }
                }

                fetch(wpURL, {
                    method: 'post',
                    body: JSON.stringify(postObj),
                    mode: 'cors',
                    headers: new Headers({
                        'Content-Type': 'application/json'
                    })
                })
                .then(response => response.json())
                .then(json => {
                    if(json.success) {
                        // Set cookie
                        if(json.data) {
                            const d = JSON.parse(json.data);
                            const link = d.link || '';

                            this.setCookie('fvb-' + this.contestType, link, 14);
                            this.populateLink(link);
                        }                  
                    } else {
                        const er = new Error;
                        er.message = JSON.stringify(json);
    
                        throw er;
                    }
                    
                })
                .catch((e) => {
                    console.log(e);
                });
            }
        } catch(e) {
            console.log(e);
        }
    }

    readCookie = (cname) => {
        const nameEQ = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
           let c = ca[i];
           while (c.charAt(0) == ' ') c = c.substring(1, c.length);
           if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    setCookie = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        const expires = "expires="+d.toUTCString();
        const samesite = "SameSite=Lax";
        document.cookie = cname + "=" + cvalue + "; " + expires + "; " + samesite;
    }
}

export default ContestLinks;